/**
 * @desc 自营散货订舱生成TMS
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfScattered/createTmsForCabin`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
